import List from '@/models/List';
import { ProgramClass } from '@/models/ProgramClass';
import { Workshop } from '@/models/Workshop';
import { compareWorkshops } from '@/services/WorkshopService';
import { ApplicationState } from '@/store';
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import ClassFormWorkshopItem from './ClassFormWorkshopItem';
import './style.scss';

interface Props {
    programClass: ProgramClass;
    courses: List[];
    programClassStartDate?: Date;
    onClick: () => void;
}

const ClassFormWorkshopSection: React.FC<Props> = ({ programClass, courses, programClassStartDate, onClick }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const getWorkshopWithConflicts = useCallback(
        (course: List, workshops?: Workshop[]) => {
            const workshopFounded = workshops?.find((workshop) => workshop.course.id === course.id);
            return compareWorkshops(strings, courses, workshopFounded, programClass.workshops);
        },
        [strings, courses, programClass.workshops],
    );

    return (
        <section className="class-form-workshop-section">
            <span className="class-form-workshop-section-title">{strings.PROGRAM_CONTENT}</span>
            <div className="class-form-workshop-section-items">
                {courses.map((course, index) => {
                    const workshop = getWorkshopWithConflicts(course, programClass.workshops);
                    return (
                        <ClassFormWorkshopItem
                            course={course}
                            index={++index}
                            key={course.id}
                            onClick={onClick}
                            programClassStartDate={programClassStartDate}
                            workshopFmt={workshop}
                        />
                    );
                })}
            </div>
        </section>
    );
};

export default memo(ClassFormWorkshopSection);
